import { TipoParentescoEnum } from "./../../../core/enums/tipo-parentesco.enum";
import { WresponseData } from "./../../../core/models/worker/wresponse-data";
import { ListaTipoIdentificacion } from "./tipo-identificacion.enum";

export class TipoIdentificacion {
  nombre: string;
  valor: string;
  max: number;
  min: number;
  rangoEdadMin: number;
  rangoEdadMax: number;
  expresionRegular: string;
}

export class TipoIdentificacionLista {
  private static TIPOIDENTIFICACIONREGISTROCIVIL: Array<TipoIdentificacion> = [
    {
      nombre: ListaTipoIdentificacion.RC.desc,
      valor: ListaTipoIdentificacion.RC.codigo,
      max: 11,
      min: 10,
      rangoEdadMin: 7,
      rangoEdadMax: 0,
      expresionRegular: "^[0-9]*$",
    },
  ];
  private static TIPOIDENTIFICACIONTARJETADEIDENTIDAD: Array<TipoIdentificacion> =
    [
      {
        nombre: ListaTipoIdentificacion.TI.desc,
        valor: ListaTipoIdentificacion.TI.codigo,
        max: 11,
        min: 10,
        rangoEdadMin: 18,
        rangoEdadMax: 7,
        expresionRegular: "^[0-9]*$",
      },
    ];

  private static TIPOIDENTIFICACIONMAYORESDAD: Array<TipoIdentificacion> = [
    {
      //Cedula de ciudadanía
      nombre: ListaTipoIdentificacion.CC.desc,
      valor: ListaTipoIdentificacion.CC.codigo,
      max: 10,
      min: 3,
      rangoEdadMin: 0,
      rangoEdadMax: 18,
      expresionRegular: "^[0-9]*$",
    },

    {
      //Carnet diplomático
      nombre: ListaTipoIdentificacion.CD.desc,
      valor: ListaTipoIdentificacion.CD.codigo,
      max: 15,
      min: 3,
      rangoEdadMin: 0,
      rangoEdadMax: 18,
      expresionRegular: "^[a-zA-Z0-9]*$",
    },
    {
      //Cedula de extranjería
      nombre: ListaTipoIdentificacion.CE.desc,
      valor: ListaTipoIdentificacion.CE.codigo,
      max: 7,
      min: 6,
      rangoEdadMin: 0,
      rangoEdadMax: 18,
      expresionRegular: "^[0-9]*$",
    },
    {
      //Pasaporte
      nombre: ListaTipoIdentificacion.PA.desc,
      valor: ListaTipoIdentificacion.PA.codigo,
      max: 15,
      min: 3,
      rangoEdadMin: 0,
      rangoEdadMax: 18,
      expresionRegular: "^[a-zA-Z0-9]*$",
    },
    {
      //Permiso protección temporal
      nombre: ListaTipoIdentificacion.PPT.desc,
      valor: ListaTipoIdentificacion.PPT.codigo,
      max: 8,
      min: 1,
      rangoEdadMin: 0,
      rangoEdadMax: 18,
      expresionRegular: "^[0-9]*$",
    },
  ];

  private static tiposDeDocumentosValidosParaConsultar: ListaTipoIdentificacion[] =
    [ListaTipoIdentificacion.CC, ListaTipoIdentificacion.RC, ListaTipoIdentificacion.TI];


  public static esValidoParaConsultar(codigo: string): boolean {
    let resultado: boolean = this.tiposDeDocumentosValidosParaConsultar.some(
      (documento) => documento.codigo === codigo
    );
    return resultado;
  }

  public static obtenerTipoidentificacionMenoresEdad(): Array<TipoIdentificacion> {
    return this.TIPOIDENTIFICACIONREGISTROCIVIL.concat(this.TIPOIDENTIFICACIONTARJETADEIDENTIDAD);
  }

  public static obtenerTipoidentificacionMayoresEdad(
    trabajador: WresponseData,
    tipoParentesco: string
  ): Array<TipoIdentificacion> {
    return this.cambiarMinimoCaractresMayoresEdad(trabajador, tipoParentesco);
  }

  public static obtenerTodosTipoidentificacion(
    trabajador: WresponseData,
    tipoParentesco: string
  ): Array<TipoIdentificacion> {
    let tipoIdentificacionCopia: Array<TipoIdentificacion> =
      this.cambiarMinimoCaractresMayoresEdad(trabajador, tipoParentesco).concat(
        this.TIPOIDENTIFICACIONREGISTROCIVIL, this.TIPOIDENTIFICACIONTARJETADEIDENTIDAD
      );
    return tipoIdentificacionCopia;
  }

  public static obtenerTipoidentificacionParaConyuge(
    trabajador: WresponseData,
    tipoParentesco: string
  ): Array<TipoIdentificacion> {
    let tipoIdentificacionCopia: Array<TipoIdentificacion> =
      this.cambiarMinimoCaractresMayoresEdad(trabajador, tipoParentesco).concat(
        this.TIPOIDENTIFICACIONTARJETADEIDENTIDAD
      );
    return tipoIdentificacionCopia;
  }

  private static cambiarMinimoCaractresMayoresEdad(
    trabajador: WresponseData,
    tipoParentesco: string
  ): Array<TipoIdentificacion> {
    let tipoIdentificacionCopia: Array<TipoIdentificacion> = JSON.parse(
      JSON.stringify(this.TIPOIDENTIFICACIONMAYORESDAD)
    );

    const min =
      (tipoParentesco === TipoParentescoEnum.HIJO ||
        tipoParentesco === TipoParentescoEnum.HIJASTRO) &&
      parseInt(trabajador.validacion_afiliado.afiliado.edad) - 12 <= 23
        ? parseInt(trabajador.validacion_afiliado.afiliado.edad) - 12
        : tipoParentesco !== TipoParentescoEnum.HIJO &&
          tipoParentesco !== TipoParentescoEnum.HIJASTRO &&
          tipoParentesco !== TipoParentescoEnum.HERMANO
        ? 100
        : 23;
    for (const i in tipoIdentificacionCopia) {
      tipoIdentificacionCopia[i].rangoEdadMin = min;
    }

    return tipoIdentificacionCopia;
  } 
}
